var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7",
    stroke: "#175783",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9",
    stroke: "#175783",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16724 16.4165C4.3462 16.6557 4.57449 16.8536 4.83661 16.9969C5.09878 17.1401 5.3887 17.2253 5.68666 17.2466C5.98466 17.268 6.28374 17.225 6.56361 17.1205C6.84353 17.0162 7.0977 16.8528 7.3089 16.6415L8.55891 15.3915C8.93841 14.9986 9.14841 14.4723 9.14366 13.9261C9.13891 13.3798 8.91978 12.8573 8.53353 12.471C8.14728 12.0848 7.62474 11.8657 7.07849 11.8609C6.53224 11.8562 6.00599 12.0662 5.61307 12.4457L4.89641 13.1582M5.83391 15.5832C5.65495 15.3439 5.42666 15.146 5.16449 15.0028C4.90236 14.8595 4.61245 14.7744 4.31445 14.753C4.01649 14.7317 3.71741 14.7747 3.43751 14.8791C3.15761 14.9835 2.90344 15.1469 2.69224 15.3582L1.44224 16.6082C1.06274 17.0011 0.852755 17.5273 0.857501 18.0736C0.862246 18.6198 1.08135 19.1423 1.46762 19.5286C1.85388 19.9149 2.37641 20.134 2.92265 20.1387C3.4689 20.1435 3.99515 19.9335 4.38807 19.554L5.10057 18.8415",
    stroke: "#175783",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.e0bd10672a405bea6b11bf2aa58179aa.svg";
export { ForwardRef as ReactComponent };